import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import notiService from '../../../services/notification.service';

const initialState = {
  listNoti: [],
  listEmail: [],
  isNotificationDetail: false,
  isEmailDetail: false,
  isEmailTemplate: false,
  isNotificationTemplate: false,
  detailNoti: {},
  detailEmail: {},
  loading: false,
  error: null,
  listVariables: [],
  isUnSave: false,
};

export const getListNoti = createAsyncThunk('/notification-templates', async (payload) => {
  const response = await notiService.getListNoti(payload);
  return response.data;
});

export const getListEmail = createAsyncThunk('/email-templates', async (payload) => {
  const response = await notiService.getListEmail(payload);
  return response.data;
});

export const getListVariables = createAsyncThunk('/variables', async (payload) => {
  const response = await notiService.getListVariables(payload);
  return response.data;
});

export const updateTemplate = createAsyncThunk('/update', async (payload, { rejectWithValue }) => {
  try {
    const response = await notiService.updateTemplate(payload);
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

const notiManagementSlice = createSlice({
  name: 'noti',
  initialState,
  reducers: {
    setIsNotificationDetail(state, action) {
      state.isNotificationDetail = action.payload;
    },
    setIsEmailDetail(state, action) {
      state.isEmailDetail = action.payload;
    },
    setDetailNoti(state, action) {
      state.detailNoti = action.payload;
    },
    setDetailEmail(state, action) {
      state.detailEmail = action.payload;
    },
    cleanUpState(state) {
      state.listNoti = initialState.listNoti;
      state.isNotificationDetail = initialState.isNotificationDetail;
      state.isEmailDetail = initialState.isEmailDetail;
      state.listVariables = initialState.listVariables;
      state.loading = initialState.loading;
      state.error = initialState.error;
    },
    setUnSave(state, action) {
      state.isUnSave = action.payload;
    },
  },
  extraReducers: (builder) => {
    // list noti
    builder.addCase(getListNoti.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getListNoti.fulfilled, (state, action) => {
      state.listNoti = action.payload;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(getListNoti.rejected, (state, action) => {
      state.error = action.payload;
      state.loading = false;
    });
    // list email
    builder.addCase(getListEmail.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getListEmail.fulfilled, (state, action) => {
      state.listEmail = action.payload;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(getListEmail.rejected, (state, action) => {
      state.error = action.payload;
      state.loading = false;
    });
    // list variables
    builder.addCase(getListVariables.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getListVariables.fulfilled, (state, action) => {
      state.listVariables = action.payload;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(getListVariables.rejected, (state, action) => {
      state.error = action.payload;
      state.loading = false;
    });
    // update
    builder.addCase(updateTemplate.fulfilled, (state) => {
      state.error = null;
    });
    builder.addCase(updateTemplate.rejected, (state, action) => {
      state.error = action.payload;
    });
  },
});

export const {
  cleanUpState,
  setIsNotificationDetail,
  setDetailNoti,
  setIsEmailDetail,
  setDetailEmail,
  setUnSave,
} = notiManagementSlice.actions;
export default notiManagementSlice.reducer;
